import { gql } from '@apollo/client';

export const ALL_PORTALS = gql`
  query AllPortals {
    portals: getPortals {
      id
      name
    }
  }
`;
